import {
  adminParsedRoutes,
  AppRoutes,
  RouteConfigDisplay,
  userParsedRoutes,
} from "@/router/routes.const";
import store from "@/store/store";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: AppRoutes,
});

// I get all the route that need to be auth
const mapOnlyNameRoute = (routes: RouteConfigDisplay) =>
  routes.map(({ name }) => name);
const authRoutes = [
  ...mapOnlyNameRoute(userParsedRoutes),
  ...mapOnlyNameRoute(adminParsedRoutes),
];

router.beforeEach((to, from, next) => {
  //@ts-ignore
  if (authRoutes.includes(to.name) && store.state.account.auth !== true) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  return next();
});

export default router;
